export default __webpack_public_path__ + "static/media/about320.72345645.jpg";